export default "__VITE_ASSET__3ec21ad9__"